import { Component } from 'vue-property-decorator';
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus';
import PaymentMethod  from '../../payment-method.vue';
import ProductItem  from '../../product-item.vue';
import { getCheckoutPlanOptionFromNickname } from '@/shared/data/plan-option-util';
import { buildInvoiceItem,  getAdditionalAuthors, removeExistingPlans, removePlanByMetadata, removePlanByNamePartial } from '@/shared/data/plan-utils';
import UpdatePlan from '../../update-plan.component';

@Component({
  components: {
    StripeElements,
    StripeElement,
    PaymentMethod,
    ProductItem
  }
})
export default class LearnerUpdatePlan extends UpdatePlan {

  public get title() {
    return this.updateAuthor ? 'Update your plan' : 'Confirm your new plan';
  }

  public get descriptionTitle() {
    return this.addSuitePlan ? 'Adding' : 'Changing to';
  }

  public invoiceItemQuantityChange(item, additionalAuthors) {
    if (item.quantity === 0 && item.authorOnly) {
      // need to replace item with author only
      this.changeToItemToAuthorOnly(item, additionalAuthors);
    } else {

      this.invoiceItems.forEach((elm) => {
        if (elm.id === item.id) {
          elm.quantity = item.quantity;
        }
      });

      this.subscriptionItems.forEach((elm) => {
        if (elm.priceId === item.priceId) {
          elm.quantity = parseInt(item.quantity);
        }

        // if (item.relatedAuthor && elm.priceId === item.relatedAuthor.priceId) {
        //   elm.quantity = parseInt(item.relatedAuthor.quantity);
        //   elm.unitPrice = item.relatedAuthor.unitPrice;
        //   elm.unitAmount = formatPrice(elm.unitPrice);
        // }
      });


      this.addOrUpdateAdditionalAuthors(item, additionalAuthors);
    }

    this.getEstimate();
  }


  public removeItem(itemIndex) {
    this.subscriptionItems[itemIndex].deleted = true;
    if (this.subscriptionItems[itemIndex].added) {
      this.subscriptionItems.splice(itemIndex, 1);
    }
  }

  public removeRelated(item) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === item.priceId);
    if (subscriptionItem) {
subscriptionItem.relatedAuthor = null;
}
  }

  public updateRelated(priceId, related) {
    const subscriptionItem = this.subscriptionItems.find((s) => s.priceId === priceId);
    if (subscriptionItem) {
      subscriptionItem.relatedAuthor = related;
    }
  }

  public addOrUpdateAdditionalAuthors(item, additionalAuthors) {
    if (item.relatedAuthor) {
      const index = this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId);
      if (index !== -1 && additionalAuthors === 0) {
        this.removeItem(index);
        this.removeRelated(item);
      } else {
        this.subscriptionItems[index].quantity = parseInt(item.relatedAuthor.quantity);
      }
    } else {
      const additional = getAdditionalAuthors(item, additionalAuthors, this.allPlans);
      if (additional) {
        this.subscriptionItems.push(additional);
        this.updateRelated(item.priceId, buildInvoiceItem(additional, this.allPlans));
      }
    }

  }

  public removeFromSubscriptionItems(itemTndex) {
    if (itemTndex !== -1) {
      this.subscriptionItems.splice(itemTndex, 1);
    }
  }

  public removePlatByNamePartial(name) {
    const index = this.availablePlans.findIndex((v) => v.productName.includes(name));
    if (index !== -1) {
      this.availablePlans.splice(index, 1);
    }
  }

  public removeExistingPlans() {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      this.removePlatByNamePartial(this.subscriptionItems[i].productName);
    }
  }

  public updateAvailablePlans() {
    const planNickname = this.subscription ? this.subscription.plan.nickname : null;
    const cleanPlans = getCheckoutPlanOptionFromNickname(planNickname, this.allPlans);
    this.availablePlans = cleanPlans.filter((val) => val['interval'] === this.billingCycle);

    // remove CVR viewers
    removePlanByNamePartial(this.availablePlans, 'viewers');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans, 'Platinum');

    // remove Ptlatinum
    removePlanByNamePartial(this.availablePlans, 'Silver');

    // remove by metadata
    removePlanByMetadata(this.availablePlans);

    // remove existing plans
    removeExistingPlans(this.subscriptionItems, this.availablePlans);

    const silver = this.subscriptionItems.find((val) => val.productName.includes('Silver'));
    if (silver) {
      this.availablePlans = [];
      return;
    }


    const gold = this.subscriptionItems.find((val) => val.productName.includes('Gold'));
    if (gold) {
      removePlanByNamePartial(this.availablePlans, 'Silver');
      removePlanByNamePartial(this.availablePlans, 'Gold');
    }
  }

  public invoiceListUpdated(itemRemoved) {
    for (let i = 0; i < this.subscriptionItems.length; i++) {
      if (itemRemoved.priceId === this.subscriptionItems[i].priceId) {
        this.subscriptionItems[i].deleted = true;
        if (this.subscriptionItems[i].added) {
          this.subscriptionItems.splice(i, 1);
        }
      }
      if (itemRemoved.productName.includes('Platinum') && this.subscriptionItems[i].productName.includes('viewers')) {
        // need to remove cvr viewers
        this.subscriptionItems[i].deleted = true;
        if (this.subscriptionItems[i].added) {
          this.subscriptionItems.splice(i, 1);
        }
      }
    }
    this.getEstimate();
  }

  public invoiceListItemRetored(itemRestored) {
    const isSilver = itemRestored.productName.includes('Silver');
    if (isSilver) {
      this.subscriptionItems = this.subscriptionItems.filter(function( obj ) {
        obj.deleted = false;
        return obj.productName.includes('Silver');
      });
    } else {
      for (let i = 0; i < this.subscriptionItems.length; i++) {
        if (itemRestored.priceId === this.subscriptionItems[i].priceId) {
          this.subscriptionItems[i].deleted = false;
        }

        if (itemRestored.productName.includes('viewers') && this.subscriptionItems[i].productName.includes('Platinum')) {
          // need to restore platinum if viewers is restored
          this.subscriptionItems[i].deleted = false;
        }
      }
    }
    this.getEstimate();
  }

  public async changeToItemToAuthorOnly(item, additionalAuthors) {
    const qty = item.learnerAuthorList[0].author + additionalAuthors;
    const index = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
    if (index !== -1) {
      this.subscriptionItems.splice(index, 1);
      if (item.relatedAuthor) {
        // need to remove additional author prices
        this.removeFromSubscriptionItems(this.subscriptionItems.findIndex((s) => s.priceId === item.relatedAuthor.priceId));
      }
      const newItem = this.allPlans.find((val) => val.priceId === item.authorOnly);

      if (newItem) {
        let learner = null;
        if (newItem.price.metadata) {
          learner = this.allPlans.find((val) => val.priceId === newItem.price.metadata.learner);
          learner = buildInvoiceItem(learner, this.allPlans);
          learner.quantity = 100;
          console.log(learner);
        }
        const subsItem = {
          productName: newItem.productName,
          quantity: qty,
          priceId: newItem.priceId,
          interval: newItem.interval,
          unitPrice: newItem.unitPrice,
          deleted: false,
          added: true,
          billing: newItem.billing,
          learner
        };

        this.subscriptionItems.push(subsItem);
      }
    }
  }

  public toLearner(learner, index, item) {
    if (index !== -1) {
      this.invoiceItems.splice(index, 1);
      this.invoiceItems.splice(index, 1, learner);

      const itemTndex = this.subscriptionItems.findIndex((s) => s.priceId === item.priceId);
      if (itemTndex !== -1) {
        const newItem = this.allPlans.find((val) => val.priceId === learner.priceId);
        if (newItem) {
          const subsItem = {
            productName: learner.productName,
            quantity: learner.quantity,
            priceId: newItem.priceId,
            interval: newItem.interval,
            unitPrice: newItem.unitPrice,
            deleted: false,
            added: true,
            billing: newItem.billing
          };
          this.subscriptionItems.splice(itemTndex, 1);
          this.subscriptionItems.splice(itemTndex, 1, subsItem);
        }
      }
    }
  }

  public previousState() {
    this.$router.go(-1);
  }


}
